import { formatMoney } from '@expenditure/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import type { GroupListItem } from '../lib/types';
import { Avatar } from './ui';

export function GroupRow({ group, to }: { group: GroupListItem; to?: string }) {
  const { t } = useTranslation();
  const amount = formatMoney(Math.abs(group.myNetMinor), group.currency);
  return (
    <Link className="list-row" to={to ?? `/groups/${group.id}`}>
      <Avatar name={group.name} />
      <div className="grow">
        <div className="list-title ellipsis">{group.name}</div>
        <div className="list-sub">
          {t('common.members', { count: group.memberCount })} · {formatMoney(group.totalSpentMinor, group.currency)}
        </div>
      </div>
      <div className="balance-end">
        {group.myNetMinor === 0 ? (
          <span className="small muted">{t('groups.settled')}</span>
        ) : (
          <>
            <span className={`small ${group.myNetMinor > 0 ? 'pos' : 'neg'}`}>
              {group.myNetMinor > 0 ? t('dashboard.youAreOwed') : t('dashboard.youOwe')}
            </span>
            <span className={`num ${group.myNetMinor > 0 ? 'pos' : 'neg'}`}>{amount}</span>
          </>
        )}
      </div>
    </Link>
  );
}
